// Libraries
var React = require('react');
var PubSub = require('pubsub-js');

// Components
var MainNavigationBar = require('./MainNavigationBar');
var MainNavigationMenu = require('./MainNavigationMenu');
var RestrictTab = require('../../../common/Accessibility/RestrictTab');

// Styles
require('./MainNavigationModule.scss');

class MainNavigationModule extends React.Component {
	constructor(props) {

		super(props);

		this.state = {
			isMenuOpen: false
		};

		this.RestrictTab = new RestrictTab();

		var overlayToggledHandler = function(message, isOpening){
			if(isOpening) {
				this.setState({ isMenuOpen: false });
			}
		}.bind(this);
		PubSub.subscribe('OverlayToggled', overlayToggledHandler);
	}

	toggleMenu = (event, cb) => {
		// Disable scrolling.
			document.querySelector('body').classList.toggle('navigation-open');

		if(!this.state.isMenuOpen) {
			this.RestrictTab.setup('.js-mainnav-start-tab', '.js-mainnav-end-tab');
		} else {
			this.RestrictTab.destroy();
		}

		// Reveal the navigation back in case is hidden.
			// This will make the menu handler aligned with the navbar.
			var hiddenElements = document.querySelectorAll('.sneakpeek--hidden');
		if (hiddenElements.length > 0) {
			for (var i = 0; i < hiddenElements.length; i++) {
				hiddenElements[i].classList.toggle('sneakpeek--hidden');
			}
		}

		this.setState({
			isMenuOpen: !this.state.isMenuOpen
		}, cb);

		const userwayWidgetElement = document.getElementById('userwayAccessibilityIcon');
		if (userwayWidgetElement) {
		  userwayWidgetElement.style.display = this.state.isMenuOpen ? 'block' : 'none';
		}
	};

	handleClose = (event) => {
		event.stopPropagation();
		if (event.key === 'Escape' || (event.key === 'Enter' && event.target === this.closeButton)) {
			event.preventDefault();
			this.toggleMenu(event, () => {
				this.openButton.focus();
			});
		}
	}

	handleOpen = (event) => {
		if(event.key === 'Enter') {
			event.preventDefault();
			this.toggleMenu(event, () => {
				this.closeButton.focus();
			});
		} else if (event.key === 'Escape') {
			this.toggleMenu(event);
		}
	}

	render() {
		return (
			<div className="MainNavigation">
				<MainNavigationBar env={this.props.data.environmentLabel} openRef={(button) => this.openButton = button} focusHandler={this.handleOpen} toggleMenu={this.toggleMenu} isMenuOpen={this.state.isMenuOpen} showLogoPoppy={this.props.data.showLogoPoppy} />
				<MainNavigationMenu closeRef={(button) => this.closeButton = button} focusHandler={this.handleClose} toggleMenu={this.toggleMenu} isMenuOpen={this.state.isMenuOpen} data={this.props.data} />
			</div>
		)
	}
}

module.exports = MainNavigationModule;



// WEBPACK FOOTER //
// ./src/components/Navigation/MainNavigation/MainNavigationModule.js